export default __webpack_public_path__ + "media/images/add-material-606848a6e1fbaba7f09449f54689a351.png";